module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"BOOKED":"Prenotato","COMPLETE":"Completato","CANCELLED":"Annullato","WAITINGFORPAYMENT":"In attesa di pagamento","CANCELLEDWITHFEE":"Annullato (pagato)"}}')
  delete Component.options._Ctor
}
